export default function recurrenceInFrench(recurrence: string) {
  switch (recurrence) {
    case 'none':
      return 'aucune';
    case 'weekly':
      return 'semaine(s)';
    case 'monthly':
      return 'mois';
    case 'yearly':
      return 'an(s)';
    default:
      return '-';
  }
}
